export const DEFAULT_PRODUCT_STATE = {
  productData: [],
  totalProductCount: 0,

  selectedProduct: null,
  selectedProductsList: [],
  selectedProductBlist: [],

  cursor: {
    before: null,
    after: null,
  },

  loading: false,
  error: null,
  success: false,

  page: 0,
  limit: 30,
  mode: 'create',

  catalogue: null,
  catalogueByMetadata: null,
  catalogFetching: false,
  catalogLoading: false,
  connectLoading: false,
  disconnectLoading: false,
};
